var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VContext',{attrs:{"eventName":"ContextInfo"},scopedSlots:_vm._u([{key:"default",fn:function({ items }){return [_c('div',{staticClass:"context-info"},[_vm._v(_vm._s(items))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }